import React, { useState } from 'react';
import './Login.css';

const Login = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
    if (error) setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate inputs
    if (!credentials.email || !credentials.password) {
      setError('Please enter both email and password');
      return;
    }
    
    setIsLoading(true);
    
    // Simulate authentication API call
    setTimeout(() => {
      // This would be your actual authentication logic
      // For demo, we'll accept these test credentials
      if (credentials.email === 'admin@admin.com' && credentials.password === 'admin123') {
        // Store auth token in localStorage (in a real app, this would be a JWT)
        localStorage.setItem('authToken', 'dummy-auth-token');
        localStorage.setItem('user', JSON.stringify({
          id: 1,
          name: 'Admin User',
          email: 'admin@admin.com',
          role: 'admin'
        }));
        
        setIsLoading(false);
        onLogin();
      } else {
        setError('Invalid email or password');
        setIsLoading(false);
      }
    }, 1000);
  };

  return (
    <div className="login-container">
      <div className="login-form-card">
        <div className="login-header">
          <h2>Admin Panel Login</h2>
          <p>Enter your credentials to access the admin panel</p>
        </div>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={credentials.email}
              onChange={handleInputChange}
              placeholder="Enter your email"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleInputChange}
              placeholder="Enter your password"
              required
            />
          </div>
                    
          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        <div className="login-footer">
          <p>Test credentials:</p>
          <p>Email: admin@admin.com | Password: admin123</p>
        </div>
      </div>
    </div>
  );
};

export default Login;